import { render } from "./Opener.vue?vue&type=template&id=23708823"
import script from "./Opener.vue?vue&type=script&lang=js"
export * from "./Opener.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__